import { format } from 'date-fns'
import { id } from 'date-fns/locale'

import type { Kinerja } from 'types/kinerja'

export const LINK_GUIDE = 'https://pusatinformasi.guru.kemdikbud.go.id/hc/en-us'

const currentDate = new Date()

const getMonthName = (month: number) => {
  return format(currentDate.setMonth(month), 'LLLL', { locale: id })
}

export const getStepsByPeriod = (period: Kinerja['period']) => {
  // If period === 2 (2nd half of the year), add 6 months to getMonthName
  const addMonths = period === 2 ? 6 : 0

  return [
    {
      title: getMonthName(0 + addMonths),
      description: ['Perencanaan dan Persetujuan Rencana.'],
    },
    {
      title: `${getMonthName(1 + addMonths)} - ${getMonthName(5 + addMonths)}`,
      description: [
        'Persiapan Praktik Kinerja.',
        'Pelaksanaan Praktik Kinerja: Observasi.',
        'Pelaksanaan Praktik Kinerja: Tindak Lanjut.',
        'Penilaian dan Penetapan Predikat Kinerja.',
      ],
    },
  ]
}
